/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	// TESTING MODE - to prevent actual form submission to support

	var TESTING_MODE = false;

	var reCaptchaEnterpriseEnabled = $('.contact-us').data('recaptcha-enterprise-enabled');
	var captchaEnabled = $('.contact-us').data('captcha-enable');

	/**
	 * Validate whole form. Requires `this` to be set to form object
	 * @param {Object} $phoneField - Phone number field input.
	 * @returns {boolean} - Flag to indicate if form is valid
	 */
	function validatePhoneNumber($phoneField) {
	    var contactPhone = $phoneField.val();
	    if (contactPhone) {
	        contactPhone = contactPhone.replace(/\s/g, '');
	        $phoneField.val(contactPhone);
	    }

	    var errorLengthLabel = '',
	        isValid = true;

	    // check if phone contains any letters (including diacritics) - if yes, it's invalid
	    if (contactPhone && /[a-zA-ZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽàâäèêëìîïòôöùûüñçăâîșțĂÂÎȘȚ]/.test(contactPhone)) {
	        errorLengthLabel = $phoneField.data('invalid-phone') || 'The phone number must not contain letters';
	        isValid = false;
	    } else {
	        // check the phone length only if no letters found
	        var minLength = $phoneField.attr('minlength'),
	            maxLength = $phoneField.data('max');
	        if (minLength && contactPhone.length < parseInt(minLength)) {
	            errorLengthLabel = $phoneField.data('minlength-error');
	            isValid = false;
	        } else if (maxLength && contactPhone.length > parseInt(maxLength)) {
	            errorLengthLabel = $phoneField.data('maxlength-error');
	            isValid = false;
	        }
	    }

	    if (isValid) {
	        $phoneField.removeClass('is-invalid custom-error');
	    } else {
	        $phoneField.parents('.cc-form-group').find('.cc-text-message').text(errorLengthLabel);
	        $phoneField.closest('.cc-content-input').removeClass('is-valid');
	        $phoneField.addClass('is-invalid custom-error');
	    }

	    /**
	     * Check the phone pattern - usefull only for th, my, id, in, cl sites. Since these sites do have an extra div (located inside
	     *  a phoneField.isml component) that encapsulates an input phone field.
	     */
	    if ($phoneField.parent().hasClass('cc-phone-input-box')) {
	        var pattern = $phoneField.attr('pattern');
	        var patternValid = pattern && !contactPhone.match(pattern) ? false : true;
	        if (patternValid && isValid) {
	            $phoneField.parent().removeClass('is-invalid custom-error');
	        } else {
	            $phoneField.parent().addClass('is-invalid custom-error');
	        }
	    }
	}

	/**
	 * Validate email field using regex pattern and proper error handling
	 * @param {Object} $emailField - Email field input element (jQuery object)
	 * @returns {boolean} - Flag to indicate if email is valid
	 */
	function validateEmailField($emailField) {
	    var emailValue = $emailField.val().trim();
	    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format validation

	    if (emailValue !== '' && !emailRegex.test(emailValue)) {
	        // Show error for invalid email format
	        $emailField.parents('.cc-form-group').find('.cc-text-message').text($emailField.data('invalid-email'));
	        $emailField.closest('.cc-content-input').removeClass('is-valid');
	        $emailField.addClass('is-invalid custom-error');
	        $('#form-contact-email-error').show();
	    } else {
	        // Hide error
	        $emailField.removeClass('is-invalid custom-error');
	        $('#form-contact-email-error').hide();
	    }
	}

	/**
	 * when the user focuses out of the contact phone input label, removes all the whitespaces if present (for example from autofill)
	*/
	$('#contact-phone').on('blur', function () {
	    validatePhoneNumber($(this));
	});

	/**
	 * Validate email on blur
	 */
	$('#contact-email').on('blur', function () {
	    validateEmailField($(this));
	});

	/**
	 * Method used when the user clicks on the button or outside of the modal and redirect to the homepage
	 */
	$('.js-submit').on('click', function (e) {
	    var $target = $(e.target);

	    if ($target.hasClass('cc-button-type-1') || $target.closest('.cc-button-type-1').length) {
	        var url = $target.data('redirecturl') || $target.closest('.cc-button-type-1').data('redirecturl');
	        if (url) {
	            window.location.href = url;
	        }
	    }
	});

	/**
	 * Focus trap for modal
	 */
	(function setupModalFocusTrap() {
	    var $modal = $('#contactUs-modal-submit');
	    var lastFocusedElement = null;

	    var getFocusableElements = function getFocusableElements() {
	        return $modal.find('button.close, .modal-title, #modal-body, .modal-footer .cc-button-type-1').filter(':visible').sort(function (a, b) {
	            return (parseInt($(a).attr('tabindex')) || 0) - (parseInt($(b).attr('tabindex')) || 0);
	        });
	    };

	    $modal.on('shown.bs.modal', function () {
	        lastFocusedElement = document.activeElement;

	        var $closeButton = $modal.find('button.close');
	        if ($closeButton.length) {
	            $closeButton.focus();
	        }

	        $modal.off('keydown.focustrap').on('keydown.focustrap', function (e) {
	            if (e.key !== 'Tab' && e.keyCode !== 9) return;

	            e.preventDefault();
	            var elements = getFocusableElements();
	            var currentIndex = elements.index(document.activeElement);
	            var nextIndex = e.shiftKey ? currentIndex <= 0 ? elements.length - 1 : currentIndex - 1 : currentIndex >= elements.length - 1 ? 0 : currentIndex + 1;

	            elements.eq(nextIndex).focus();
	        });
	    });

	    $modal.on('hidden.bs.modal', function () {
	        $modal.off('keydown.focustrap');

	        var $submitButton = $('#contact-submit-btn');
	        if ($submitButton.length) {
	            $submitButton.focus();
	        } else if (lastFocusedElement) {
	            lastFocusedElement.focus();
	        }
	    });
	})();

	/**
	 * Initialize aria-live announcer on page load (required for Firefox browser)
	 */
	$(function () {
	    $('body').append('<div id="form-error-announcer" role="alert" aria-live="assertive" aria-atomic="true" class="sr-only"></div>');
	});

	/**
	 * Announce validation errors to screen readers
	 */
	function announceValidationErrors(errors) {
	    if (!errors || errors.length === 0) return;

	    var announcer = document.getElementById('form-error-announcer');
	    if (announcer) {
	        announcer.textContent = '';
	        setTimeout(function () {
	            announcer.textContent = errors.join('. ');
	        }, 50);
	    }
	}

	/**
	 * Collect and announce validation errors
	 */
	(function () {
	    var errors = [],
	        timer = null;

	    $('form#contact-us .required').on('invalid', function () {
	        var $field = $(this);
	        $field.addClass('is-invalid custom-error');

	        if ($field.attr('id') === 'contact-phone' && $field.parent().hasClass('cc-phone-input-box')) {
	            $field.parent().addClass('is-invalid custom-error');
	        } else if ($field.attr('id') === 'contact-email') {
	            $('#form-contact-email-error').show();
	        }

	        var $group = $field.closest('.cc-form-group');
	        var label = ($field.attr('type') === 'checkbox' ? $group.find('.cc-check-label') : $group.find('.cc-label')).text().trim();
	        var message = $field.data('missing-error') || '';

	        if (label && message) {
	            var error = label + ': ' + message;
	            if (errors.indexOf(error) === -1) errors.push(error);
	        }

	        // announce after all invalid events complete
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            announceValidationErrors(errors);
	            errors = [];
	        }, 100);
	    });
	})();

	/**
	 * Count remaining characters in comment field
	 */
	function countCommentWords() {
	    if ($('#contact-comment').length > 0) {
	        $('#contact-comment').on('keyup', function () {
	            var count = $('#wordCommentCounter');
	            var maxLength = $(this).attr('maxlength');
	            var newMaxLengthValue = parseInt(maxLength);
	            count.text(newMaxLengthValue - this.value.length);
	        });
	    }
	}

	// Captcha error handling
	window.captchaError = function () {
	    if (captchaEnabled !== null && captchaEnabled) {
	        $('.captchaMessage').removeClass('d-none');
	        $('.captchaMessage').addClass('invalid-captcha custom-error');
	    }
	};

	// Captcha success handling
	window.captchaSuccess = function () {
	    if (captchaEnabled !== null && captchaEnabled) {
	        $('.captchaMessage').addClass('d-none');
	        $('.captchaMessage').removeClass('invalid-captcha custom-error');
	    }
	};

	// Reset captcha widget
	window.captchaReset = function () {
	    if (captchaEnabled !== null && captchaEnabled) {
	        reCaptchaEnterpriseEnabled ? window.grecaptcha.enterprise.reset() : window.grecaptcha.reset();
	    }
	};

	/**
	 * Collect and announce all form validation errors to screen readers
	 */
	function announceAllFormErrors() {
	    var errors = [];
	    var seen = {};

	    $('form#contact-us .cc-form-group').each(function () {
	        var $group = $(this);
	        var $field = $group.find('.required');
	        var label = ($field.attr('type') === 'checkbox' ? $group.find('.cc-check-label') : $group.find('.cc-label')).text().trim();

	        if (!label || seen[label]) return;

	        var hasError = $field.hasClass('is-invalid') || $field.hasClass('custom-error');
	        if ($field.attr('id') === 'contact-phone' && $field.parent().hasClass('cc-phone-input-box')) {
	            hasError = hasError || $field.parent().hasClass('is-invalid') || $field.parent().hasClass('custom-error');
	        }

	        if (hasError) {
	            var message = $group.find('.cc-text-message').text().trim() || $field.data('missing-error') || '';
	            if (message) {
	                errors.push(label + ': ' + message);
	                seen[label] = true;
	            }
	        }
	    });

	    announceValidationErrors(errors);
	}

	/**
	 * Contact form submission handler
	 */
	function subscribeContact() {
	    var $form = $('form#contact-us');

	    $form.find('.required').on('input change', function () {
	        var $field = $(this);
	        var announcer = document.getElementById('form-error-announcer');

	        if (announcer) {
	            announcer.textContent = '';
	        }

	        $field.removeClass('is-invalid custom-error');
	        $field.closest('.cc-form-group').find('.cc-text-message').text('');

	        if ($field.attr('id') === 'contact-phone' && $field.parent().hasClass('cc-phone-input-box')) {
	            $field.parent().removeClass('is-invalid custom-error');
	        }
	    });

	    $form.find('button[type="submit"]').on('click', function () {
	        setTimeout(announceAllFormErrors, 300);
	    });

	    $('form#contact-us').on('submit', function (e) {
	        e.preventDefault();
	        var form = $(this);
	        var url = form.attr('action');
	        var topic = form.find('#contact-topic option:selected').text().trim();
	        $('input#topic-hidden').attr('value', topic);

	        var captcha = null;
	        // Validate reCAPTCHA if enabled
	        if (captchaEnabled) {
	            captcha = reCaptchaEnterpriseEnabled ? window.grecaptcha.enterprise.getResponse() : window.grecaptcha.getResponse();
	            if (captcha.length === 0) {
	                window.captchaError();
	                $('.error-message-contact-us').show();
	                //var test = $('.custom-error').first().parents('.cc-form-group');
	                document.querySelector('.error-message-contact-us').scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	                $.spinner().stop();
	            } else {
	                window.captchaSuccess();
	                $('input#captcha-token').attr('value', captcha);
	            }
	        }

	        // Validate form fields
	        validatePhoneNumber($('#contact-phone'));
	        validateEmailField($('#contact-email'));

	        // Submit if no validation errors
	        if ($('.custom-error').length === 0) {
	            // TESTING MODE - Show modal without sending to support
	            if (TESTING_MODE) {
	                var bodyText = 'This is a test. No message was sent to support.';
	                $('#exampleModalLongTitle').text('Test Mode');
	                $('#modal-body').text(bodyText).attr('aria-label', bodyText);
	                $('#contactUs-modal-submit').modal('show');
	                return;
	            }

	            $.spinner().start();
	            $.ajax({
	                url: url,
	                type: 'POST',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    // in case of error, reset the captcha token to avoid timeout
	                    if (!!data.serverErrors && data.serverErrors.length) {
	                        window.captchaReset();
	                        $('.error-message-contact-us').show();
	                        $('.error-message-text-contact-us').text(data.serverErrors);
	                        document.querySelector('.error-message-contact-us').scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	                    } else {
	                        // Show success modal
	                        $('#exampleModalLongTitle').text(data.title);
	                        $('#modal-body').text(data.msg).attr('aria-label', data.msg);
	                        $('#contactUs-modal-submit').modal('show');
	                    }
	                    $.spinner().stop();
	                },
	                error: function error(err) {
	                    // Show error modal
	                    $('#exampleModalLongTitle').text(err.title);
	                    $('#modal-body').text(err.msg).attr('aria-label', err.msg);
	                    $.spinner().stop();
	                    $('#contactUs-modal-submit').modal('show');
	                }
	            });
	        }
	    });
	}

	$('label[for="contact-personal-data"]').on('keydown', function (e) {
	    if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32) {
	        if ($(e.target).is('a')) return; // Let links work normally

	        e.preventDefault();
	        var checkbox = $('#contact-personal-data');
	        checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
	    }
	});

	$('#contact-personal-data').on('change', function () {
	    $('label[for="contact-personal-data"]').attr('aria-checked', this.checked ? 'true' : 'false');
	});

	$(document).on('keydown', 'button[data-id="contact-topic"]', function (e) {
	    if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32) {
	        e.preventDefault();
	        e.stopPropagation();
	        $(this).click();
	    }
	});

	// Bootstrap selectpicker keyboard navigation (Narrator/VoiceOver Firefox accessibility)
	document.addEventListener('keydown', function (e) {
	    var $dd = $('.bootstrap-select.show');
	    var $cur = $(document.activeElement);
	    if (!$dd.length || !$cur.closest('.dropdown-menu').length || e.keyCode !== 9 && e.keyCode !== 13) return;

	    e.preventDefault();
	    e.stopPropagation();
	    e.stopImmediatePropagation();

	    if (e.keyCode === 13) return $cur.click();

	    var $items = $dd.find('.dropdown-menu li:not(.disabled):not(.hidden)');
	    var idx = $items.index($cur.closest('li'));
	    var next = e.shiftKey ? idx <= 0 ? $items.length - 1 : idx - 1 : idx >= $items.length - 1 ? 0 : idx + 1;

	    $items.removeClass('active').find('a').removeClass('active');
	    var $item = $items.eq(next).addClass('active');
	    var $link = $item.find('a').addClass('active');

	    $link.focus();
	    $item[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
	}, true);

	// Bootstrap dropdown option Firefox Windows Narrator accessibility fix
	$('#contact-topic').on('shown.bs.select', function () {
	    var $dd = $(this).parent();
	    var labelPrefix = $('#topic-label').text().trim();

	    $('#topic-label').attr('aria-hidden', 'true');
	    $dd.find('button.dropdown-toggle').attr('aria-hidden', 'true');
	    var $lb = $dd.find('.dropdown-menu .inner[role="listbox"]').attr('tabindex', '0');

	    $dd.find('.dropdown-menu a[role="option"]').each(function () {
	        var $link = $(this);
	        var optionText = $link.find('.text').text().trim();
	        $link.attr('role', 'button').attr('aria-label', labelPrefix + ': ' + optionText);
	    });

	    setTimeout(function () {
	        $lb[0].focus();
	    }, 100);
	}).on('hidden.bs.select', function () {
	    var $dd = $(this).parent();
	    $('#topic-label').attr('aria-hidden', 'false');
	    $dd.find('button.dropdown-toggle').attr('aria-hidden', 'false');
	    $dd.find('.dropdown-menu .inner[role="listbox"]').attr('tabindex', '-1');
	});

	// Initialize
	subscribeContact();
	countCommentWords();

	// Fix aria-label for comment description 
	var $commentDesc = $('.cc-form-description[role="text"]');
	if ($commentDesc.length > 0) {
	    var textContent = $commentDesc.text().trim();
	    $commentDesc.attr('aria-label', textContent);
	}

	$('#contact-topic').attr('tabindex', '-1');

	// Bootstrap selectpicker force-sets tabindex=-1 on dropdown, breaking keyboard navigation and making duplicated dropdown for screenreaders.
	(function () {
	    var orig = HTMLElement.prototype.setAttribute;
	    HTMLElement.prototype.setAttribute = function (n, v) {
	        if (n === 'tabindex' && v == -1 && this.getAttribute('data-id') === 'contact-topic') v = 0;
	        return orig.call(this, n, v);
	    };
	})();

	// Accessibility text for Bootstrap Dropdown
	function updateDropdownAriaLabel() {
	    var $btn = $('button[data-id="contact-topic"]');
	    var label = $('#contact-topic').data('label-prefix');
	    var text = $btn.find('.filter-option-inner-inner').text().trim();
	    if (label && text) {
	        $btn.find('.filter-option').attr('aria-hidden', 'true');
	        $btn.removeAttr('title').attr('aria-label', text + ', ' + label);
	    }
	}

	setTimeout(function () {
	    $('button[data-id="contact-topic"]').attr('tabindex', '0');
	    $('#contact-topic').parent('.bootstrap-select').attr('tabindex', '-1');
	    updateDropdownAriaLabel();
	}, 200);

	$('#contact-topic').on('changed.bs.select', updateDropdownAriaLabel);

/***/ })
/******/ ]);